<template>
  <section class="page-section">
        <!-- filter -->
        <div class="filter-region no-margin-top">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="订单号：" prop="orderNo">
                <el-input v-model="filterForm.orderNo" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="交易流水号：" prop="transactionId">
                <el-input v-model="filterForm.transactionId" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="下单人昵称：" prop="userName">
                <el-input v-model="filterForm.userName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="下单人ID：" prop="userId">
                <el-input v-model="filterForm.userId" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="收货人手机号：" prop="mobile">
                <el-input v-model="filterForm.mobile" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="顾客所属管家：" prop="serviceUserId">
                <el-select v-model="filterForm.serviceUserId" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.id" :label="item.serviceUserName"
                    :value="item.serviceUserId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品名：" prop="commodityName">
                <el-autocomplete class="inline-input" v-model="filterForm.commodityName"
                  :fetch-suggestions="querySearch" :trigger-on-focus="false" placeholder="请输入"></el-autocomplete>
              </el-form-item>
              <el-form-item label="购买方式：" prop="isPoints">
                <el-select v-model="filterForm.isPoints" placeholder="请选择">
                  <el-option v-for="item in purchaseTypeOptions" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="下单时间：" prop="orderTime" class="auto-width">
                <el-date-picker v-model="filterForm.orderTime" type="daterange" value-format="yyyy-MM-dd"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="time-shortcut">
                <el-button plain @click="getLastFewDays(-7)"
                  :class="{ 'is-active': isActiveShortcut(-7) }">近7天</el-button>
                <el-button plain @click="getLastFewDays(-30)"
                  :class="{ 'is-active': isActiveShortcut(-30) }">近30天</el-button>
              </el-form-item>

            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>
        <div class="tab-account">
          <el-tabs class="mt-20 no-margin-top" v-model="tabName" type="card" @tab-click="handleTabsChange">
            <el-tab-pane label="全部" name="-2"></el-tab-pane>
            <el-tab-pane label="待付款" name="0"></el-tab-pane>
            <el-tab-pane label="待发货" name="1"></el-tab-pane>
            <el-tab-pane label="已发货" name="2"></el-tab-pane>
            <el-tab-pane label="已完成" name="4"></el-tab-pane>
            <el-tab-pane label="已关闭" name="-1"></el-tab-pane>
            <!-- <el-tab-pane label="退款中" name="5"></el-tab-pane> -->
            <!-- <el-tab-pane label="退款失败" name="6"></el-tab-pane> -->
            <!-- <el-tab-pane label="退款成功" name="7"></el-tab-pane> -->
          </el-tabs>
          <div class="trade-amount-box">
            <div class="trade-amount-card">
              <img src="../../../assets/actuallyPriceSum.png" class="card-icon" />
              <div class="card-content">
                <div class="card-header">
                  营收总额（元）
                </div>
                <div class="card-value">{{ tradeAmount.actuallyPriceSum }}</div>
              </div>
            </div>
            <div class="trade-amount-card">
              <img src="../../../assets/actuallyPricePoints.png" class="card-icon" />
              <div class="card-content">
                <div class="card-header">
                  积分营收总额（元）
                </div>
                <div class="card-value">{{ tradeAmount.actuallyPricePoints }}</div>
              </div>
            </div>
            <div class="trade-amount-card">
              <img src="../../../assets/actuallyPriceNotPoints.png" class="card-icon" />
              <div class="card-content">
                <div class="card-header">
                  商品营收总额（元）
                </div>
                <div class="card-value">{{ tradeAmount.actuallyPriceNotPoints }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- table -->
        <div class="table-region mt-10" v-loading="tableLoading">
          <!-- 自定义表格 -->
          <div class="custom-table">
            <div class="custom-table-header">
              <el-row :gutter="10">
                <el-col :span="7">
                  <div class="table-cell">商品</div>
                </el-col>
                <el-col :span="1">
                  <div class="table-cell">数量</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">商品单价</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">税费单价</div>
                </el-col>
                <el-col :span="1">
                  <div class="table-cell">关联管家</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">实付金额</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">下单时间</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">下单人昵称-ID</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">收货人信息</div>
                </el-col>
                <el-col :span="1">
                  <div class="table-cell">订单状态</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell text-align-right">操作</div>
                </el-col>
              </el-row>
            </div>
            <div class="custom-table-body">
              <div class="no-data" v-if="tableData.length == 0">暂无数据</div>
              <!-- order item -->
              <div class="order-list-item" v-for="(item, index) in tableData" :key="index" v-else>
                <div class="item-header">
                  <el-row :gutter="10">
                    <el-col :span="22">
                      <div class="table-cell">
                        <el-row :gutter="10">
                          <el-col :span="24">
                            <p class="text">订单号：{{ item.orderNo }}</p>
                            <span style="margin-left: 20px;">交易流水号：{{ item.transactionId || '顾客未支付' }}</span>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="table-cell text-align-right">
                        <el-button type="text" size="small"
                          @click="pageNavigateToOrderOrderDetail(item)">查看详情</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div class="item-body">
                  <el-row :gutter="10">
                    <!-- 商品 -->
                    <el-col :span="7">
                      <div class="table-cell">
                        <el-row :gutter="10" v-for="(scope, index) in item.itemList" :key="index">
                          <el-col>
                            <div class="table-cell">
                              <div class="img-wrap" style="height: auto; align-items: center">
                                <div class="img-box">
                                  <img :src="scope.url">
                                </div>
                                <div style="flex: 1">
                                  <span class="text particular" style="height: auto">{{ scope.commodityName }}</span>
                                  <p class="text" style="" v-for="(it, index) in scope.skuList" :key="index">
                                    <span style="height: auto">{{ it.name }}：{{ it.value }}</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <!-- 数量 -->
                    <el-col :span="1">
                      <div class="table-cell">
                        <div class="table-cell" style="height: 68px;" v-for="(scope, index) in item.itemList"
                          :key="index">
                          <div class="flex-v" style="justify-content: center;width: 100%;height: 100%;">
                            <p>{{ scope.num }}</p>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <!-- 商品单价 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <div class="table-cell" style="height: 68px;" v-for="(scope, index) in item.itemList"
                          :key="index">
                          <div class="flex-v" style="justify-content: center;width: 100%;height: 100%;">
                            <p>￥{{ scope.unitPrice }}</p>
                            <p>₩{{ scope.unitKoreaPrice }}</p>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <!-- 税费单价 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <div class="table-cell" style="height: 68px;" v-for="(scope, index) in item.itemList"
                          :key="index">
                          <div class="flex-v" style="justify-content: center;width: 100%;height: 100%;">
                            <p>￥{{ scope.ratePrice || '-' }}</p>
                            <p>₩{{ scope.rateKoreaPrice || '-' }}</p>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <!-- 关联管家 -->
                    <el-col :span="1">
                      <div class="table-cell">
                        <p class="text">{{ item.serviceUserName }}</p>
                      </div>
                    </el-col>
                    <!-- 实付金额 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <p class="text">￥{{ item.actuallyPrice }}</p>
                      </div>
                    </el-col>
                    <!-- 下单时间 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <p class="text">{{ item.orderDate }}</p>
                      </div>
                    </el-col>
                    <!-- 收货人昵称 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <p class="text">{{ item.userName }} </br> ID:{{ item.userId }}</p>
                      </div>
                    </el-col>
                    <!-- 收货人信息 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <p class="text">{{ item.receiverName }}</p>
                        <p class="text">{{ item.receiverPhone }}</p>
                        <p class="text particular">{{ item.addressDetail }}</p>
                      </div>
                    </el-col>
                    <!-- 订单状态 -->
                    <el-col :span="1">
                      <div class="table-cell">
                        <p class="text" v-if="item.status == -1">已关闭</p>
                        <p class="text" v-if="item.status == 0">待付款</p>
                        <p class="text" v-if="item.status == 1">待发货</p>
                        <p class="text" v-if="item.status == 2">已发货</p>
                        <p class="text" v-if="item.status == 4">已完成</p>
                        <p class="text" v-if="item.status == 9">退款中</p>
                        <p class="text" v-if="item.status == 10">退款成功</p>
                        <p class="text" v-if="item.status == 11">退款失败</p>
                      </div>
                    </el-col>
                    <!-- 操作 -->
                    <el-col :span="2">
                      <div class="table-cell text-align-right">
                        <!-- <el-button v-if="item.status == 0" type="text" size="small" @click="handleEditFreight(item)">修改运费</el-button> -->
                        <!-- <el-button v-if="item.status == 1" type="text" size="small" @click="handleDeliverGoods(item)">发货</el-button> -->
                        <p v-if="item.status == 2" class="text status-after">已发货</p>
                        <el-button v-if="item.status == 2" type="text" size="small"
                          @click="handleDeliverGoods(item)">修改物流信息</el-button>
                        <el-button v-if="item.status == 1" type="text" size="small"
                          @click="handleCancelOrder(item)">取消订单</el-button>
                        <el-button
                          v-if="(item.status == 2 || item.status == 4 || item.status == 11) && item.refundType == 1"
                          type="text" size="small" @click="handleReturnOrder(item)">申请退款</el-button>
                        <el-button
                          v-if="(item.status == 2 || item.status == 4 || item.status == 11) && item.refundType == 2"
                          type="text" size="small" @click="handleCancelOrder(item)">申请退款</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate"></div>
          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>

<!-- 修改运费弹窗 -->
<el-dialog title="修改运费" :visible.sync="dialogEditDeliverShow" width="400px">
  <el-form size="small" ref="formDialog" :model="formDialog" label-width="90px" class="dialog-form">
    <el-form-item label="配送方式">
      <p class="text">快递</p>
    </el-form-item>
    <el-form-item label="收货人">
      <p class="text">{{ formDialog.receiverName }} {{ formDialog.receiverPhone }}</p>
    </el-form-item>
    <el-form-item label="收货地址">
      <p class="text">{{ formDialog.addressDetail }}</p>
    </el-form-item>
    <el-form-item label="修改前运费">
      <p class="text">￥{{ formDialog.freightPrice }}</p>
    </el-form-item>
    <el-form-item label="修改后运费">
      <el-input type="number" class="w150" v-model="formDialog.freight">
        <template slot="prepend">¥</template>
      </el-input>
    </el-form-item>
  </el-form>

  <span slot="footer" class="dialog-footer">
    <el-button size="small" plain @click="dialogEditDeliverShow = false">取 消</el-button>
    <el-button size="small" type="primary" @click="editDeliverGoods" :loading="dialogLoading">确 定</el-button>
  </span>
</el-dialog>
<!-- 发货弹窗 -->
<el-dialog title="订单发货" :visible.sync="dialogDeliverShow" width="400px">
  <el-form size="small" ref="formDialog" :model="formDialog" label-width="80px" class="dialog-form">
    <el-form-item label="收货人">
      <p class="text">{{ formDialog.receiverName }} {{ formDialog.receiverPhone }}</p>
    </el-form-item>
    <el-form-item label="收货地址">
      <p class="text">{{ formDialog.addressDetail }}</p>
    </el-form-item>
    <el-form-item label="快递公司">
      <el-select v-model="formDialog.deliverId" class="w200" placeholder="">
        <el-option v-for="(item, index) in formDialog.deliverCompany" :label="item.deliverName" :value="item.id"
          :key="index"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="快递单号">
      <el-input v-model="formDialog.deliverNo" class="w200"></el-input>
    </el-form-item>
  </el-form>

  <span slot="footer" class="dialog-footer">
    <el-button size="small" plain @click="dialogDeliverShow = false">取 消</el-button>
    <el-button size="small" type="primary" @click="deliverGoods" :loading="dialogLoading">确 定</el-button>
  </span>
</el-dialog>
<!-- 取消订单弹窗 -->
<el-dialog title="取消订单" :visible.sync="dialogCancelShow" width="400px">
  <el-form size="small" ref="formDialog" :model="formDialog" label-width="110px" class="dialog-form">
    <el-form-item label="退款金额">
      <el-input v-model="formDialog.refundPrice" type="number" class="w200"></el-input>
    </el-form-item>
    <el-form-item label="取消原因">
      <el-input type="textarea" :rows="5" v-model="formDialog.refundReason" class="w200"></el-input>
    </el-form-item>
  </el-form>

  <span slot="footer" class="dialog-footer">
    <el-button size="small" plain @click="dialogCancelShow = false">取 消</el-button>
    <el-button size="small" type="primary" @click="cancelOrder" :loading="dialogLoading">确 定</el-button>
  </span>
</el-dialog>
<!-- 申请退款弹窗 -->
<el-dialog title="申请退款" :visible.sync="dialogReturnShow" width="400px">
  <el-form size="small" ref="formDialog" :model="formDialog" label-width="110px" class="dialog-form">
    <el-form-item label="退款金额">
      <el-input v-model="formDialog.refundPrice" type="number" class="w200"></el-input>
    </el-form-item>
    <el-form-item label="退款原因">
      <el-input type="textarea" :rows="5" v-model="formDialog.refundReason" class="w200"></el-input>
    </el-form-item>
  </el-form>

  <span slot="footer" class="dialog-footer">
    <el-button size="small" plain @click="dialogReturnShow = false">取 消</el-button>
    <el-button size="small" type="primary" @click="returnOrder" :loading="dialogLoading">确 定</el-button>
  </span>
</el-dialog>
      </section>
</template>
<script>
import { orderListCount, orderList, orderFreightEdit, orderDeliver, orderDeliverCompany, cancelReturnOrder, commodityNameList, COMMON, list } from '../../../common/api'
export default {
  name: 'goodsManageList',
  data() {
    return {
      tabName: '-2', // 选项卡name 订单类型
      filterForm: { // 筛选表单值
        orderNo: '', // 订单号
        transactionId: '', // 交易流水号
        userName: '', // 下单人姓名
        userId: '', // 下单人ID
        mobile: '', // 手机号
        orderTime: '', // 下单时间起止点
        serviceUserId: '', // 服务商id
        commodityName: '', // 商品名称
        isPoints: '', // 购买方式
      },
      options: [], //管家
      purchaseTypeOptions: [{ label: '兑换', value: '1' }, { label: '购买', value: '0' }], //购买方式
      page: { // 分页参数
        current: 1,
        size: 20,
        total: 0
      },
      tableLoading: true,
      tableData: [], // 表格数据
      goodsList: [], // 商品列表
      dialogEditDeliverShow: false, // 修改运费弹窗
      dialogDeliverShow: false, // 发货弹窗
      dialogCancelShow: false, // 取消订单弹窗
      dialogReturnShow: false, // 申请退款弹窗
      dialogLoading: false,
      formDialog: {
        // 弹窗公用
        orderId: '', // 订单id
        status: '', // 订单状态值
        receiverName: '', // 收货人
        receiverPhone: '', // 收货手机号
        addressDetail: '', // 收货地址
        // 发货弹窗   
        deliverId: '', // 快递公司id
        deliverNo: '', // 快递单号 
        deliverCompany: [], // 快递公司列表           
        // 修改运费弹窗
        freightPrice: '', // 修改前运费
        freight: '', // 修改后运费
        // 取消订单/退款弹窗
        refundReason: '', // 取消订单/退款原因
        refundPrice: '' // 退款金额
      },
      tradeAmount: {}
    }
  },
  methods: {
    // 获取管家列表
    getManagerList() {
      list().then(res => {
        if (res.data.length === 0) {
          this.$message.error('暂无管家信息');
          return;
        }
        this.options = res.data;
      }).catch(() => {
        this.$message.error('获取管家列表失败');
      })
    },
    /**
     * [getCommodityNameList description] 获取商品名列表
     * @return {[type]} [description]
     */
    getCommodityNameList: function () {
      this.goodsList = [];
      commodityNameList().then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          for (let i in data) {
            this.goodsList.push({ value: data[i] });
          }
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      })
    },
    /**
     * [getDeliverCompanyList description] 获取快递公司
     * @return {[type]} [description]
     */
    getDeliverCompanyList: function () {
      orderDeliverCompany().then(res => {
        let { code, data, msg } = res;
        if (code == 0) {
          this.formDialog.deliverCompany = data || [];
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      })
    },
    // 获取订单统计
    getOrderListCount() {
      let param = {
        "orderNo": this.filterForm.orderNo,
        "transactionId": this.filterForm.transactionId,
        'userName': this.filterForm.userName,
        'userId': this.filterForm.userId,
        "mobile": this.filterForm.mobile,
        "startDate": this.filterForm.orderTime ? this.filterForm.orderTime[0] : '',
        "endDate": this.filterForm.orderTime ? this.filterForm.orderTime[1] : '',
        'commodityName': this.filterForm.commodityName,
        "serviceUserId": this.filterForm.serviceUserId,
        'isPoints': this.filterForm.isPoints,
      }
      orderListCount(param).then(res => {
        let { code, data, msg } = res;
        if (code == 0) {
          this.tradeAmount = data;
        } else {
          this.$message.error(msg);
        }
      })
    },
    // 获取表格数据
    getList: function () {
      this.tableLoading = true;
      let param = {
        "orderNo": this.filterForm.orderNo,
        "transactionId": this.filterForm.transactionId,
        'userName': this.filterForm.userName,
        'userId': this.filterForm.userId,
        "mobile": this.filterForm.mobile,
        "startDate": this.filterForm.orderTime ? this.filterForm.orderTime[0] : '',
        "endDate": this.filterForm.orderTime ? this.filterForm.orderTime[1] : '',
        'commodityName': this.filterForm.commodityName,
        'isPoints': this.filterForm.isPoints,
        "current": this.page.current,
        "serviceUserId": this.filterForm.serviceUserId,
        "size": this.page.size
      }
      if (Number(this.tabName) != -2) {
        param.status = Number(this.tabName);
      }
      console.log(param)
      orderList(param).then(res => {
        this.tableLoading = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.tableData = data.records || [];
          this.page.total = data.total;
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.tableLoading = false;
        this.$message.error('服务器异常');
      })
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    // 切换选项卡
    handleTabsChange: function (tab, event) {
      // this.filterFormReset('filterForm');
      this.page.current = 1;
      this.page.size = 20;
      this.getList();
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.page.current = 1;
          this.page.size = 20
          this.getList();
          this.getOrderListCount();
        } else {
          return false;
        }
      });
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [pageNavigateToOrderOrderDetail description] 查看订单详情
     * @param  {[Object]} item [description] 当前操作的订单对象
     * @return {[type]}          [description]
     */
    pageNavigateToOrderOrderDetail: function (item) {
      this.$router.push({ path: '/order/order/detail', query: { id: item.id } })
    },
    /**
     * [handleEditFreight description] 打开修改运费弹窗
     * @param  {[Object]} item [description] 当前操作的订单对象
     * @return {[type]}          [description]
     */
    handleEditFreight: function (item) {
      this.formDialog.freight = '';
      this.formDialog.orderId = item.id;
      this.formDialog.receiverName = item.receiverName;
      this.formDialog.receiverPhone = item.receiverPhone;
      this.formDialog.addressDetail = item.addressDetail;
      this.formDialog.freightPrice = item.freightPrice;
      this.dialogEditDeliverShow = true;
    },
    /**
     * [editDeliverGoods description] 修改运费
     * @return {[type]}          [description]
     */
    editDeliverGoods: function () {
      if (this.formDialog.freight == '') {
        this.$message.error('请输入修改后的运费');
        return false;
      }
      this.dialogLoading = true;
      let param = {
        'id': this.formDialog.orderId,
        'freight': this.formDialog.freight
      }
      orderFreightEdit(param).then(res => {
        this.dialogLoading = false;
        this.dialogEditDeliverShow = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success('修改成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
        this.dialogLoading = false;
        this.dialogEditDeliverShow = false;
      })
    },
    /**
     * [handleDeliverGoods description] 打开发货弹窗
     * @param  {[Object]} item [description] 当前操作的订单对象
     * @return {[type]}          [description]
     */
    handleDeliverGoods: function (item) {
      this.formDialog.deliverId = '';
      this.formDialog.deliverNo = '';

      if (item.status == 2) {
        this.formDialog.deliverId = Number(item.deliverId);
        this.formDialog.deliverNo = item.deliverNo;
      }
      this.formDialog.orderId = item.id;
      this.formDialog.status = item.status;
      this.formDialog.receiverName = item.receiverName;
      this.formDialog.receiverPhone = item.receiverPhone;
      this.formDialog.addressDetail = item.addressDetail;
      this.dialogDeliverShow = true;
    },
    /**
     * [changeDeliveryWay description] 发货弹窗切换配送方式
     * @param  {[Number]} val [description] 当前切换到的配送方式所对应的值
     * @return {[type]}          [description]
     */
    changeDeliveryWay: function (val) {
      this.formDialog.deliverId = '';
      this.formDialog.deliverNo = '';
    },
    /**
     * [deliverGoods description] 确认发货
     * @return {[type]}          [description]
     */
    deliverGoods: function () {
      if (this.formDialog.deliverId == '') {
        this.$message.error('请选择快递公司');
        return false;
      }
      if (this.formDialog.deliverNo == '') {
        this.$message.error('请输入快递单号');
        return false;
      }
      this.dialogLoading = true;
      let param = {
        'orderId': this.formDialog.orderId,
        'deliverId': this.formDialog.deliverId,
        'deliverNo': this.formDialog.deliverNo,
        'type': this.formDialog.status == 2 ? 2 : 1
      }
      orderDeliver(param).then(res => {
        this.dialogLoading = false;
        this.dialogDeliverShow = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success('发货成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
        this.dialogLoading = false;
        this.dialogDeliverShow = false;
      })
    },
    /**
     * [handleCancelOrder description] 打开取消订单弹窗
     * @param  {[Object]} item [description] 当前操作的订单对象
     * @return {[type]}          [description]
     */
    handleCancelOrder: function (item) {
      this.formDialog.orderId = item.id;
      this.dialogCancelShow = true;
    },
    /**
     * [cancelOrder description] 取消订单
     * @return {[type]}          [description]
     */
    cancelOrder: function () {
      this.dialogLoading = true;
      let param = {
        'orderId': this.formDialog.orderId,
        'refundReason': this.formDialog.refundReason,
        'refundPrice': this.formDialog.refundPrice,
        'refundType': 2
      }
      cancelReturnOrder(param).then(res => {
        this.dialogLoading = false;
        this.dialogCancelShow = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success('取消成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
        this.dialogLoading = false;
        this.dialogCancelShow = false;
      })
    },
    /**
     * [handleReturnOrder description] 打开申请退款弹窗
     * @param  {[Object]} item [description] 当前操作的订单对象
     * @return {[type]}          [description]
     */
    handleReturnOrder: function (item) {
      this.formDialog.orderId = item.id;
      this.dialogReturnShow = true;
    },
    /**
     * [cancelOrder description] 申请
     * @return {[type]}          [description]
     */
    returnOrder: function () {
      this.dialogLoading = true;
      let param = {
        'orderId': this.formDialog.orderId,
        'refundReason': this.formDialog.refundReason,
        'refundPrice': this.formDialog.refundPrice,
        'refundType': 1
      }
      cancelReturnOrder(param).then(res => {
        this.dialogLoading = false;
        this.dialogReturnShow = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success('申请成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
        this.dialogLoading = false;
        this.dialogReturnShow = false;
      })
    },
    /**
     * [getLastFewDays description] 获取近几日日期
     * @param  {[Number]} day [description] 需要获取的近几日的数值
     * @return {[type]}        [description]
     */
    getLastFewDays: function (day) {
      this.filterForm.orderTime = [];
      this.filterForm.orderTime.push(COMMON.getDay(day));
      this.filterForm.orderTime.push(COMMON.getDay(0));
    },
    /**
     * 判断时间快捷选项是否处于选中状态
     */
    isActiveShortcut(day) {
      if (!this.filterForm.orderTime || this.filterForm.orderTime.length !== 2) return false;
      return this.filterForm.orderTime[0] === COMMON.getDay(day) &&
        this.filterForm.orderTime[1] === COMMON.getDay(0);
    },
    // 商品搜索联想
    querySearch(queryString, cb) {
      var goodsList = this.goodsList;
      var results = queryString ? goodsList.filter(this.createFilter(queryString)) : goodsList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (goodsList) => {
        return (goodsList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    }
  },
  mounted() {
    this.getCommodityNameList();
    this.getDeliverCompanyList();
    this.getList();
    this.getOrderListCount();
    this.getManagerList();
  }
}
</script>
<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";

.mr-10 {
  margin-right: 10px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-10 {
  margin-top: 10px !important;
}

.dialog-body-title {
  text-indent: 15px;
  margin-bottom: 10px;
  font-size: $baseFS;
}

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-form-item {
    &.time-shortcut {
      background: initial;
      padding: 0;

      :deep(.el-form-item__content) {
        width: auto;

        .el-button {
          width: 110px;
          height: 40px;
          border-radius: 5px;

          &.is-active {
            border: 1px solid #3388FF;
            color: #3388FF;
            background-color: #ecf5ff;
          }
        }
      }
    }
  }


  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.tab-account {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // flex-wrap: wrap;
  height: 80px;

  .trade-amount-box {
    display: flex;
    align-items: stretch;

    .trade-amount-card {
      height: 60px;
      padding: 10px;
      border-radius: 6px;
      margin: 0 7px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      background: #F1F7FF;

      .card-icon {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }

      .card-content {
        display: flex;
        flex-direction: column;

        .card-header {
          line-height: 17px;
          font-size: 14px;
          color: #888;

        }

        .card-value {
          line-height: 25px;
          font-size: 18px;
          color: #666666;
          font-weight: 600;
        }
      }
    }
  }
}


.table-region {
  margin-bottom: 50px;

  .custom-table {

    .custom-table-header {
      padding-right: 4px;
      text-align: center;
      scrollbar-gutter: stable;
    }

    .custom-table-body {
      padding-right: 4px;
      text-align: center;

      .particular {
        text-align: left;
      }
    }
  }

}
</style>
